import { EventEmitter } from 'events';
import dispatcher from '../dispatcher/dispatcher';

/**
 * User store that stores the user information along with the jwt token and if they are logged in
 */
class UserStore extends EventEmitter {
    constructor() {
        super();
        this.JWTtoken = "";
        this.user = {};
        this.userLoggedIn = false;
        this.logout = "";
    }

    setLogout(logout) {
        this.logout = logout;
    }
    /**
     * sets the user
     * @param {#} jwtObj 
     */
    setUser(jwtObj) {
        this.JWTtoken = jwtObj.authToken;
        this.user = jwtObj.user;
        this.userLoggedIn = true;
        this.emit("User-Changes");
    }
    /**
     * Used to manipulate the stage
     * @param {*} stage 
     */
    setUserStage(stage) {
        this.user.stage = stage;
        this.emit("User-Changes");
    }
    //may not need this
    userLogOut() {
        // if (sessionStorage.getItem('auth-token')) {
        sessionStorage.clear();
        // }
        this.JWTtoken = "";
        this.user = {};
        this.userLoggedIn = false;

        this.emit("User-Changes");
    }
    actionHandler(action) {
        switch (action.type) {
            case 'SET_USER_DATA': {
                this.setUser(action.object);
                break;
            }
            case 'SET_USER_STAGE': {
                this.setUserStage(action.object);
                break;
            }
            case 'LOGOUT_USER': {
                this.userLogOut();
                break;
            }
            case 'SET_LOGOUT': {
                this.setLogout(action.object);
                break;
            }
            default: {
                break;
            }
        }
    }
}

const userStore = new UserStore();
dispatcher.register(userStore.actionHandler.bind(userStore));

export default userStore;


// WEBPACK FOOTER //
// ./src/store/userStore.js